import { Heading, Section } from 'components'
import React from 'react'
import { InlineWidget } from 'react-calendly'
import { theme } from '/tailwind.config'
// import ReactPlayer from 'react-player'

const {
  extend: { colors: themeColors },
} = theme

const calendlyUrl = 'https://calendly.com/leadboxer/application'
// const wistiaUrl = 'https://www.leadboxer.com/demo/?wvideo=4e8xbkiizh'
// const videoUrl = 'https://youtu.be/wRsDYLtI1kM'

const TempDemo = () => {
  return (
    <Section fullHeight>
      <div className="grid grid-cols-12 gap-24 items-center place-content-stretch">
        <div className="space-y-6 col-span-5 ">
          <Heading type="kicker">Book a demo</Heading>
          <Heading>Need to identify your leads & customers?</Heading>
          <p className="text-xl">
            Schedule a call to find out how we can help.
          </p>

          <p>
            Whether it’s a product walkthrough, specific questions or a casual
            chat on how to gain more insights from your online audience – our
            product experts have you covered.{' '}
            <strong>Pick the day and time</strong> on the right to schedule your
            1-on-1 call.
          </p>

          {/* <div>
            <div className="player-wrapper">
              <ReactPlayer
                className="react-player"
                url={videoUrl}
                width="100%"
                height="100%"
              />
            </div>
            <p className="my-2 text-sm text-gray-400 text-center">
              Watch a quick introduction of what LeadBoxer can do for your
              company.
            </p>
          </div> */}
        </div>
        <div className="overflow-hidden col-span-7 flex w-full flex-wrap">
          <div className="2xl:bg-gray-50 rounded border border-gray-100 overflow-hidden w-full h-full">
            <InlineWidget
              pageSettings={{
                backgroundColor: 'ffffff',
                hideEventTypeDetails: true,
                hideLandingPageDetails: true,
                primaryColor: themeColors.primary['500'].replace('#', ''),
                textColor: themeColors.gray['600'].replace('#', ''),
              }}
              scrolling="no"
              frameborder="0"
              styles={{
                height: '720px',
              }}
              url={calendlyUrl}
            />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default TempDemo
